import React from 'react'
import { Card, Grid, Skeleton, csx, Text, Radio } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { useOrderForm } from '../../../../core/requests/checkout'
import type { PurchaseConditionPrice } from '../Advertisements/types'
import { useAssemblyItemsContext } from './context/AssemblyItemsContext'
import { isChecked } from './utils/isChecked'
import { AssemblyItemsFormattedPrice } from './AssemblyItemsFormattedPrice'
import { AssemblyItemsDiscountText } from './AssemblyItemsDiscountText'

export type AssemblyItemSelectRadioProps = {
  currentAssemblyItemId: string
  hasDiscount: boolean
  isLoadingSimulation: boolean
  purchaseConditionPrice: PurchaseConditionPrice | undefined
  minQuantity: number
  maxQuantity: number
  currentAssembly: {
    id: string
    name: string
    imageUrl: string
    assemblyId: string
    seller: string
  }
}

export const AssemblyItemSelectRadio = ({
  hasDiscount,
  isLoadingSimulation,
  purchaseConditionPrice,
  minQuantity,
  maxQuantity,
  currentAssembly,
}: AssemblyItemSelectRadioProps) => {
  const { assemblyItemState, setAssemblyItemState } = useAssemblyItemsContext()
  const { getCurrencyCode } = useOrderForm()
  const currencyCode = getCurrencyCode()

  const handleCheckAssemblyItem = () => {
    setAssemblyItemState(currentAssembly, minQuantity, maxQuantity)
  }

  return (
    <Card
      key={currentAssembly.id}
      className={csx({
        display: 'grid',
        padding: '1.375rem',
        rowGap: '2.875rem',
        cursor: 'pointer',
        border: isChecked(assemblyItemState.values, currentAssembly)
          ? '$mainSelected'
          : '$neutral',
        ':hover': {
          background: '$blue05',
        },
      })}
      onClick={handleCheckAssemblyItem}
    >
      <Radio
        label=""
        value={currentAssembly.id}
        checked={isChecked(assemblyItemState.values, currentAssembly)}
      />
      <Grid templateColumns="repeat(2, 1fr)">
        <Text>{currentAssembly.name}</Text>
        <div className={csx({ textAlign: 'end' })}>
          {isLoadingSimulation ? (
            <Skeleton
              className={csx({
                display: 'inline-block',
                width: '50%',
                height: '1rem',
              })}
            />
          ) : purchaseConditionPrice ? (
            <>
              {hasDiscount && (
                <AssemblyItemsDiscountText
                  listPrice={purchaseConditionPrice?.listPrice}
                  currencyCode={currencyCode}
                  isDisabled={false}
                />
              )}
              <AssemblyItemsFormattedPrice
                value={purchaseConditionPrice?.price}
                currencyCode={currencyCode}
                isDisabled={false}
              />
            </>
          ) : (
            <Text tone="secondary">
              <FormattedMessage id="unavailable" />
            </Text>
          )}
        </div>
      </Grid>
    </Card>
  )
}
